// hooks/useFamilies.ts

import { useQueryClient, useMutation } from "@tanstack/react-query";
import {
  Family,
  FamilyCreateDTO,
  FamilyWithMembers,
} from "../../interfaces/DTO/crm/family";
import { familyService } from "../../services/crm/familyService";

import { createCachedEntityHooks } from "../createEntityHooks";
import { queryKeys } from "../../queries/queryKeys";

const FIVE_MINUTES = 5 * 60 * 1000;

export const {
  useAll: useFamilies,
  useEntityById: useFamilyById,
  useEntityListByField: useFamiliesByField,
  useCreateEntity: useCreateFamily,
  useUpdateEntity: useUpdateFamily,
  usePartialUpdateEntity: usePartialUpdateFamily,
  useDeleteEntity: useDeleteFamily,
} = createCachedEntityHooks<Family>({
  entityName: "families",
  service: familyService,
  enableCacheById: true,
  staleTimeMs: FIVE_MINUTES,
  defaultOrderBy: "updated_at",
  defaultOrderDesc: true,
});


// יצירת משפחה עם חברים
export const useCreateFamilyWithMembers = () => {
  const queryClient = useQueryClient();

  return useMutation<FamilyWithMembers, Error, FamilyCreateDTO>({
    mutationFn: (data) => familyService.createFamilyWithMembers(data),
    onSuccess: (createdFamily) => {
      // שמירה לפי ID
      queryClient.setQueryData(
        queryKeys.familyById(createdFamily.id),
        createdFamily
      );

      // עדכון לרשימה
      queryClient.setQueryData<Family[]>(queryKeys.families, (oldFamilies) => {
        if (!oldFamilies) return [createdFamily];
        const exists = oldFamilies.some((f) => f.id === createdFamily.id);
        return exists
          ? oldFamilies.map((f) =>
              f.id === createdFamily.id ? createdFamily : f
            )
          : [...oldFamilies, createdFamily];
      });
    },
  });
};
